import { Link } from '@mui/material'
import Typography from '@mui/material/Typography'
import React from 'react'
import { FormattedMessage } from 'react-intl'

export const PrivacyAndTerms = (): React.ReactElement => (
    <Typography variant="caption" sx={{ color: 'text.secondary', fontSize: '12px' }}>
        <FormattedMessage
            id="login_privacy"
            defaultMessage="{privacy} & {terms}"
            values={{
                privacy: <Link
                    href="https://www.conductorone.com/privacy-policy"
                    sx={{
                        color: 'text.secondary',
                        fontSize: '12px',
                    }}
                >
                    <FormattedMessage id="login_privacy" defaultMessage="Privacy" />
                </Link>,
                terms: <Link
                    href="https://www.conductorone.com/terms"
                    sx={{
                        color: 'text.secondary',
                        fontSize: '12px',
                    }}
                >
                    <FormattedMessage id="login_terms" defaultMessage="Terms" />
                </Link>,
            }}
        />
    </Typography>
)
